import { useState } from "react";
import { SiteData } from "./Data/SiteData";
import generateGlobalStyleFromSiteData, { GetBlogStyling } from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";


export default function RenderSiteStyle( {siteData}:{siteData:SiteData}){

    const [renderTrigger,setRenderTrigger] = useState(false);

    siteData.onUpdateStyle = ()=>{
        setRenderTrigger(!renderTrigger);
        siteData.isStylePublishDirty =true;
        siteData.isStyleSaveDirty = true;
        if(siteData.designer)
            siteData.designer.flagDirtySave();
    };

    const styleString = generateGlobalStyleFromSiteData(siteData.siteStyling);
    const blogString = GetBlogStyling(siteData.siteStyling.blogInfo)

    return <>

        <IncludeCustomFonts siteData={siteData}/>
    <style id="site-main-styling" dangerouslySetInnerHTML={{__html:styleString + blogString}}></style>

    </>

  }


 export function IncludeCustomFonts({siteData}:{siteData:SiteData}){



    return <>
{
    siteData.siteStyling.customFonts.map((f,i)=>{

        if(f.startsWith("http"))
            return   <link  key ={i } rel="stylesheet" href={f}></link>
        else
            return null;

    })
}

    </>


  }